import React from "react";
import style from "css/layout.module.css";

function Stacked({
  onDrop,
  onDragOver,
  onDragLeave,
  onDragStart,
  speakerMode,
}) {
  return (
    <table
      id="stacked"
      className={style.template_table}
      onDrop={(e) => onDrop(e)}
      onDragOver={(e) => onDragOver(e)}
      onDragLeave={(e) => onDragLeave(e)}
      onDragStart={(e) => onDragStart(e)}
    >
      <tbody className={style.row_2}>
        <tr>
          <td
            className="endpoint_area speakerArea"
            id="7"
            colSpan={6}
            draggable={speakerMode ? false : true}
            style={{
              backgroundImage: speakerMode
                ? "url('" +
                  process.env.REACT_APP_CLIENT_URL +
                  "img/layout/speaker_icon.png')"
                : "url('" +
                  process.env.REACT_APP_CLIENT_URL +
                  "img/layout/number/1.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
        </tr>

        <tr>
          <td
            className="endpoint_area"
            id="6"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/2.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="5"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/3.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="4"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/4.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="3"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/5.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="2"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/6.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
          <td
            className="endpoint_area"
            id="1"
            draggable
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/layout/number/7.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></td>
        </tr>
      </tbody>
    </table>
  );
}

export default Stacked;
